import { RightOutlined, SearchOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Input, PageHeader, Row, Select, Space, Spin } from 'antd'

import JcpMonthlyPaidListView from '../../components/enrollment/jcp/JcpMonthlyPaidListView'
import ProgrammeService from '../../api/programme.service'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import PaymentPaidList from '../../components/payment/PaymentPaidList'

import { SUCCESS_STATUS } from '../../utility/Constants'
import memberService from "../../api/member.service";
import JcpMonthlyReminderListView from "../../components/enrollment/jcp/JcpMonthlyReminderListView";
import PhysicalFitnessMonthlyReminderListView from "../../components/enrollment/physicallfitness/PhysicalFitnessMonthlyReminderListView";
import CustomTableSearch from "../../components/common/CustomTableSearch";
const { Option } = Select;





const currdate = new Date();
//const currMonth = currdate.toLocaleString('default', { month: 'short' });
const currMonth = currdate.getMonth() + 1;
const currYear = currdate.getFullYear();


const defaultFormValues = {
    month_id: currMonth,
    year: currYear,
    member_id: "",
    programme_id: 0,
    paid_unpaid_status: "ALL"
};


const PhysicalFitnessMonthlyReminder = () => {
    const [form] = Form.useForm();
    const [monthList, setMonthList] = useState([]);
    const [yearList, setYearList] = useState([]);
    const [memberList, setMemberList] = useState([]);
    const [programmeID, setProgrammeID] = useState(0);
    const [jcpMonthlyUnPaidList, setJcpMonthlyUnPaidList] = useState([]);
    const [filteredSearchList, setFilteredSearchList] = useState([]);

    const [reminderLoaderEnable, setReminderLoaderEnable] = useState(false);


    const onJcpMonthlySearched = async (values) => {
        setJcpMonthlyUnPaidList([])
        setReminderLoaderEnable(true)
        const data = { formdata: values };
        
        ProgrammeService.monthlyPaidUnPaidJcp(data).then((res) => {
            setJcpMonthlyUnPaidList(res.data.response_data)
            setFilteredSearchList(res.data.response_data)
        }).then(() => {
            setReminderLoaderEnable(false)
        });
    };

    const onSelectMember = (value) => {
        form.setFieldsValue({
            member_id:value
        });
    };

    const onClearMember = (val) => {
        if(val==undefined || val==null || val=="" ) {
            form.setFieldsValue({
                member_id:0
            });   
        }
    }
    
    const onSearch = (e) => {
     
        setFilteredSearchList([]);
        const string = e.target.value;
        const filtered_list = jcpMonthlyUnPaidList.filter((data) => JSON.stringify(data).toLowerCase().indexOf(string.toLowerCase()) !== -1);
        setFilteredSearchList(filtered_list)
       
    }

    useEffect(() => {
        ProgrammeService.yearList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setYearList(res.data.response_data);
            }

        });
    }, []);


    useEffect(() => {
        ProgrammeService.monthList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setMonthList(res.data.response_data);
            }

        });
    }, []);


    useEffect(() => {
        const data = {
            formdata: { short_code: "PF" },
        };
        ProgrammeService.programmeByCode(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setProgrammeID(res.data.response_data[0].programme_id);
                form.setFieldsValue({
                    programme_id: res.data.response_data[0].programme_id,
                });
            }
        });
    }, []);


    useEffect(() => {

        const data = {
            formdata: { programme_id: "PF" },
        };
        ProgrammeService.memberListPromoted(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setMemberList(res.data.response_data);
            }
        });
    }, []);


    useEffect(() => {
        const defaultFormValuesInitial = {
            month_id: currMonth,
            year: currYear,
            member_id: "",
            programme_id: programmeID,
            paid_unpaid_status: "ALL"
        };
        
        onJcpMonthlySearched(defaultFormValuesInitial)
    }, [programmeID])



    return (




        <div>


            <div className="inside-main-content">
                <AdminBreadCrumb />

                <div className="box-style">
                    <PageHeader
                        ghost={false}
                        onBack={() => window.history.back()}
                        title="Monthly Due Reminder - Physicall Fitness"
                        subTitle=""

                    ></PageHeader>

                    <Row className="" style={{ background: "#f4f4f4" }}>
                        <Col className="" xs={24} xl={24}>
                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={onJcpMonthlySearched}
                                autoComplete="off"
                                initialValues={defaultFormValues}
                            >

                                <Row gutter={20}>

                                    <Col xs={4} xl={4} style={{ margin: "0.5rem" }}>
                                        <Form.Item name="month_id" label="Month" rules={[
                                            {
                                                required: true,
                                                message: "Select Month",
                                            },
                                        ]}>
                                            <Select className="text-left">

                                                {
                                                    monthList.length > 0 ?
                                                        monthList.map(month_list => (
                                                            <Option key={month_list.id} value={month_list.id}>{month_list.short_name}</Option>

                                                        ))
                                                        : ''
                                                }
                                            </Select>
                                        </Form.Item>
                                    </Col>

                                    <Col xs={4} xl={4} style={{ margin: "0.5rem" }}>
                                        <Form.Item name="year" label="Year" rules={[
                                            {
                                                required: true,
                                                message: "Select Year",
                                            },
                                        ]} >
                                            <Select className="text-left"  >

                                                {
                                                    yearList.length > 0 ?
                                                        yearList.map(year_data => (
                                                            <Option key={year_data.year} value={year_data.year}>{year_data.year}</Option>

                                                        ))
                                                        : ''
                                                }
                                            </Select>
                                        </Form.Item>
                                    </Col>

                                    <Col xs={4} xl={4} style={{ margin: "0.5rem" }}>
                                        <Form.Item name="paid_unpaid_status" label="Status"  >
                                            <Select className="text-left" >
                                                <Option key="ALL" value="ALL">All</Option>
                                                <Option key="PAID" value="PAID">Paid</Option>
                                                <Option key="UNPAID" value="UNPAID">Unpaid</Option>

                                            </Select>
                                        </Form.Item>
                                    </Col>

                                    <Col xs={6} xl={6} style={{ margin: "0.5rem" }}>
                                        <Form.Item
                                            name="member_id"
                                            label="Search (Name | Mobile no | Father Name)"

                                        >
                                            <Select
                                                showSearch
                                                placeholder="Search to Select"
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    //option.children.includes(input)
                                                    option.children.toLowerCase().includes(input.toLowerCase())
                                                }

                                                // filterOption={(inputValue, option) =>
                                                //     option.children.join('').toLowerCase().includes(inputValue.toLowerCase())
                                                //   }

                                                filterSort={(optionA, optionB) =>
                                                    optionA.children
                                                        .toLowerCase()
                                                        .localeCompare(optionB.children.toLowerCase())
                                                }
                                                onSelect={(value, event) =>
                                                    onSelectMember(value, event)
                                                }
                                                allowClear={true}
                                                onChange={value => onClearMember(value)}
                                            >
                                                {memberList.length > 0
                                                    ? memberList.map((member_list) => (
                                                        <Option
                                                            key={member_list.member_id}
                                                            value={member_list.member_id}
                                                        >
                                                            {`${member_list.member_fname} ${member_list.member_lname
                                                                } | ${member_list.primary_mobile}  ${member_list.father_name != null
                                                                    ? member_list.father_name
                                                                    : ""
                                                                }`}
                                                        </Option>
                                                    ))
                                                    : ""}
                                            </Select>
                                            <Form.Item name="programme_id" hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>
                                        </Form.Item>
                                    </Col>

                                    {/* <Col xs={4} xl={4} style={{ margin: "0.5rem" }}>
                                        <Form.Item label=" ">
                                            <Button type="primary" htmlType="submit" shape="round">Show</Button>

                                        </Form.Item>
                                    </Col> */}


                                    <Col xs={4} xl={4} style={{ margin: "0.5rem" }}>
                                        <Form.Item label=" ">


                                            {
                                                reminderLoaderEnable ? <Spin /> : <>
                                                    <Button
                                                        htmlType="submit"
                                                        shape="round"

                                                        className="custom-button-green"
                                                    >
                                                        Search <SearchOutlined />
                                                    </Button>
                                                </>
                                            }

                                        </Form.Item>
                                    </Col>



                                </Row>
                            </Form>



                        </Col>
                    </Row>

                    <CustomTableSearch onSearchTable={onSearch} />
                    <div className='tableView'>
                        <div className="form-content">
                            {/* <PhysicalFitnessMonthlyReminderListView jcpMonthlyUnPaidList={jcpMonthlyUnPaidList} /> */}
                            <PhysicalFitnessMonthlyReminderListView jcpMonthlyUnPaidList={filteredSearchList} />
                        </div>
                    </div>

                </div>
            </div>

        </div>







    )
}

export default PhysicalFitnessMonthlyReminder